var AccountContentTypes = /* @__PURE__ */ ((AccountContentTypes2) => {
  AccountContentTypes2["LocalizedText"] = "localizedtext";
  AccountContentTypes2["Module"] = "modules";
  AccountContentTypes2["BaseContainer"] = "base_container";
  AccountContentTypes2["ModuleSettings"] = "_module_settings";
  AccountContentTypes2["SignInSecurity"] = "sign_in_security";
  AccountContentTypes2["AddressBookLanding"] = "address_book_landing";
  AccountContentTypes2["AddressForm"] = "address_form";
  AccountContentTypes2["DigitalMembershipCard"] = "digital_membership_card";
  AccountContentTypes2["Preference"] = "preference";
  AccountContentTypes2["CitiPaymentMethod"] = "citi_payment_method";
  return AccountContentTypes2;
})(AccountContentTypes || {});
var AccountCSPagesEnums = /* @__PURE__ */ ((AccountCSPagesEnums2) => {
  AccountCSPagesEnums2["PaymentMethods"] = "payment_methods";
  return AccountCSPagesEnums2;
})(AccountCSPagesEnums || {});
var ContentType = /* @__PURE__ */ ((ContentType2) => {
  ContentType2["AccordionSet"] = "accordion_set";
  ContentType2["AdBuilder"] = "ad_builder";
  ContentType2["AdSet3rdParty"] = "ad_set_3rd_party";
  ContentType2["AdSetCostco"] = "ad_set_costco";
  ContentType2["AnnouncementBanner"] = "announcement_banner";
  ContentType2["BulletDetailAccordion"] = "bullet_detail_accordion";
  ContentType2["BulletDetailCard"] = "bullet_detail_card";
  ContentType2["ButtonSet"] = "button_set";
  ContentType2["Category"] = "category";
  ContentType2["CategoryLandingPage"] = "category_landing_page";
  ContentType2["ConfigurationSetting"] = "Configuration_Setting";
  ContentType2["ContentDivider"] = "content_divider";
  ContentType2["CouponSet"] = "coupon_set";
  ContentType2["CustomMarkdown"] = "custom_markdown";
  ContentType2["CustomRichText"] = "custom_rich_text";
  ContentType2["DynamicContentPlacement"] = "_dynamic_content_placement";
  ContentType2["FeatureHighlightCard"] = "feature_highlight_card";
  ContentType2["FeatureHighlightCardV2"] = "feature_highlight_card_v2";
  ContentType2["FeaturePage"] = "feature_page";
  ContentType2["FeatureToggle"] = "Feature_Toggle";
  ContentType2["Footer"] = "footer_scaffold";
  ContentType2["GenericForm"] = "form_generic";
  ContentType2["GenericContentPage"] = "generic_content_page";
  ContentType2["Header"] = "header_scaffold";
  ContentType2["HomePage"] = "homepage";
  ContentType2["HomePageV2"] = "home_page_v2";
  ContentType2["LinkFlyout"] = "link_flyout";
  ContentType2["LinkListSimple"] = "link_list_simple";
  ContentType2["LinkListWithFlyout"] = "link_list_with_flyout";
  ContentType2["LinkListWithFlyoutReferences"] = "link_list_with_flyout_references";
  ContentType2["MVMPage"] = "mvm_page";
  ContentType2["ModuleSettings"] = "_module_settings";
  ContentType2["PageSettings"] = "_page_settings";
  ContentType2["PdpMarketingComponent"] = "_pdp_marketing_component";
  ContentType2["ProductConcierge"] = "product_concierge";
  ContentType2["PopupBuilder"] = "popup_builder";
  ContentType2["ProgramCard"] = "program_card";
  ContentType2["ProgressiveForm"] = "form_progressive";
  ContentType2["ServiceConfiguration"] = "Service_Configuration";
  ContentType2["SiteSettings"] = "_site_settings";
  ContentType2["SystemDefinedLink"] = "system_defined_link";
  ContentType2["Tabs"] = "tabs";
  ContentType2["TextBuilder"] = "text_builder";
  ContentType2["TieredOfferCard"] = "tiered_offer_card";
  ContentType2["SegmentBasedEntry"] = "segment_based_entry";
  ContentType2["WarehouseDetailsPage"] = "warehouse_details_page";
  ContentType2["WarehouseLocationsPage"] = "warehouse_locations_page";
  return ContentType2;
})(ContentType || {});
export {
  AccountCSPagesEnums,
  AccountContentTypes,
  ContentType
};
